import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { ADD, DELETE, EDIT, GET_ALL, GET } from "./actionTypes";
import { addApi, getAllApi, getApi, editApi, deleteApi } from "api/reviews";
import {
  addReviewFailure,
  addReviewSuccess,
  deleteReviewFailure,
  deleteReviewSuccess,
  editReviewFailure,
  editReviewSuccess,
  getAllReviewsFailure,
  getAllReviewsSuccess,
  getReviewFailure,
  getReviewSuccess,
} from "./actions";

function* getAll({ payload }) {
  try {
    const { data } = yield call(getAllApi, payload);
    yield put(getAllReviewsSuccess(data));
  } catch (error) {
    yield put(getAllReviewsFailure(error.response?.data || error));
  }
}

function* add({ payload }) {
  try {
    const { data } = yield call(addApi, payload.data);

    yield put(addReviewSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(addReviewFailure(error.response?.data || error));
  }
}

function* get({ payload }) {
  try {
    const { data } = yield call(getApi, payload);
    yield put(getReviewSuccess(data));
  } catch (error) {
    yield put(getReviewFailure(error.response?.data || error));
  }
}

function* edit({ payload }) {
  try {
    const { data } = yield call(editApi, {
      data: payload.data,
      id: payload.id,
    });

    yield put(editReviewSuccess(data));
    payload?.navigate(-1);
  } catch (error) {
    yield put(editReviewFailure(error.response?.data || error));
  }
}

function* deleteFunc({ payload }) {
  try {
    yield call(deleteApi, payload);
    yield put(deleteReviewSuccess(payload));
  } catch (error) {
    yield put(deleteReviewFailure(error.response?.data || error));
  }
}

export function* watchGetAll() {
  yield takeEvery(GET_ALL, getAll);
}

export function* watchAdd() {
  yield takeEvery(ADD, add);
}

export function* watchGet() {
  yield takeEvery(GET, get);
}

export function* watchEdit() {
  yield takeEvery(EDIT, edit);
}

export function* watchDelete() {
  yield takeEvery(DELETE, deleteFunc);
}

function* saga() {
  yield all([
    fork(watchGetAll),
    fork(watchAdd),
    fork(watchGet),
    fork(watchEdit),
    fork(watchDelete),
  ]);
}

export default saga;
